// client/src/lib/icons.js
import PersonIcon from '@mui/icons-material/Person';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import Groups3OutlinedIcon from '@mui/icons-material/Groups3Outlined';
import LinkIcon from '@mui/icons-material/Link';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ArticleIcon from '@mui/icons-material/Article';
import HomeIcon from '@mui/icons-material/Home';
import PdfIcon from '@mui/icons-material/PictureAsPdf';
import NearMeOutlinedIcon from '@mui/icons-material/NearMeOutlined';
import DialpadOutlinedIcon from '@mui/icons-material/DialpadOutlined';
import LocalActivityOutlinedIcon from '@mui/icons-material/LocalActivityOutlined';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import SettingsIcon from '@mui/icons-material/Settings';
import PeopleIcon from '@mui/icons-material/People';
import BusinessIcon from '@mui/icons-material/Business';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import TroubleshootSharpIcon from '@mui/icons-material/TroubleshootSharp';

// Optional: if you want "custom" icons for images
import StartHereImage from '../resources/images/icons/light/Iconography_white_Growth.png';
import ProfileIconImage from '../resources/images/icons/light/Iconography_white_Individuals.png';
import MyReportsImage from '../resources/images/icons/light/Iconography_white_Quantitive risk management.png';
import BalanceImage from '../resources/images/icons/light/Iconography_white_Value.png';

export const IconMap = {
  PersonIcon,
  FormatListBulletedIcon,
  FormatListNumberedIcon,
  AccountBalanceIcon,
  Groups3OutlinedIcon,
  LinkIcon,
  AccountBalanceWalletIcon,
  ArticleIcon,
  HomeIcon,
  PdfIcon,
  NearMeOutlinedIcon,
  DialpadOutlinedIcon,
  LocalActivityOutlinedIcon,
  SupportAgentIcon,
  FilterAltIcon,
  PersonAddIcon,
  SettingsSuggestIcon,
  SettingsIcon,
  PeopleIcon,
  BusinessIcon,
  AccountTreeIcon,
  QueryStatsIcon,
  TroubleshootSharpIcon,

  // Optional custom images as "icons" (can be rendered via <img src={IconMap.StartHereImage} />)
  StartHereImage,
  ProfileIconImage,
  MyReportsImage,
  BalanceImage
};
